// Mock data for PropertyARV - Real Estate Investment Analysis Software

export const mockComparables = [
  {
    id: 1,
    address: "123 Oak Street",
    city: "Austin",
    state: "TX",
    zip: "78701",
    price: 425000,
    beds: 3,
    baths: 2,
    sqft: 1850,
    pricePerSqft: 230,
    yearBuilt: 2005,
    soldDate: "2025-06-15",
    distance: 0.3,
    matchScore: 95,
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400",
    lat: 30.2672,
    lng: -97.7431
  },
  {
    id: 2,
    address: "456 Maple Avenue",
    city: "Austin",
    state: "TX",
    zip: "78702",
    price: 398000,
    beds: 3,
    baths: 2,
    sqft: 1720,
    pricePerSqft: 231,
    yearBuilt: 2008,
    soldDate: "2025-05-20",
    distance: 0.5,
    matchScore: 88,
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400",
    lat: 30.2650,
    lng: -97.7380
  },
  {
    id: 3,
    address: "789 Pine Lane",
    city: "Austin",
    state: "TX",
    zip: "78703",
    price: 445000,
    beds: 4,
    baths: 2.5,
    sqft: 2100,
    pricePerSqft: 212,
    yearBuilt: 2010,
    soldDate: "2025-06-01",
    distance: 0.7,
    matchScore: 82,
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400",
    lat: 30.2700,
    lng: -97.7500
  },
  {
    id: 4,
    address: "321 Cedar Court",
    city: "Austin",
    state: "TX",
    zip: "78704",
    price: 385000,
    beds: 3,
    baths: 2,
    sqft: 1650,
    pricePerSqft: 233,
    yearBuilt: 2012,
    soldDate: "2025-04-28",
    distance: 0.9,
    matchScore: 78,
    image: "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=400",
    lat: 30.2620,
    lng: -97.7550
  },
  {
    id: 5,
    address: "555 Elm Drive",
    city: "Austin",
    state: "TX",
    zip: "78705",
    price: 412000,
    beds: 3,
    baths: 2,
    sqft: 1800,
    pricePerSqft: 229,
    yearBuilt: 2007,
    soldDate: "2025-05-10",
    distance: 1.1,
    matchScore: 75,
    image: "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=400",
    lat: 30.2750,
    lng: -97.7350
  }
];

export const mockRepairCategories = [
  {
    category: "Kitchen",
    items: [
      { name: "Cabinet Refinishing", lowCost: 1500, highCost: 3500 },
      { name: "Cabinet Replacement", lowCost: 8000, highCost: 15000 },
      { name: "Countertops (Granite)", lowCost: 2000, highCost: 4500 },
      { name: "Countertops (Quartz)", lowCost: 3000, highCost: 6000 },
      { name: "Appliance Package", lowCost: 2500, highCost: 5000 },
      { name: "Flooring", lowCost: 1200, highCost: 3000 },
      { name: "Lighting", lowCost: 500, highCost: 1500 }
    ]
  },
  {
    category: "Bathroom",
    items: [
      { name: "Full Remodel", lowCost: 8000, highCost: 15000 },
      { name: "Vanity Replacement", lowCost: 800, highCost: 2500 },
      { name: "Tile Work", lowCost: 1500, highCost: 4000 },
      { name: "Fixtures Update", lowCost: 500, highCost: 1500 },
      { name: "Tub/Shower Replacement", lowCost: 1200, highCost: 3500 }
    ]
  },
  {
    category: "Exterior",
    items: [
      { name: "Roof Replacement", lowCost: 8000, highCost: 20000 },
      { name: "Roof Repair", lowCost: 500, highCost: 2500 },
      { name: "Siding", lowCost: 5000, highCost: 15000 },
      { name: "Paint Exterior", lowCost: 2500, highCost: 6000 },
      { name: "Windows", lowCost: 3000, highCost: 10000 },
      { name: "Landscaping", lowCost: 1500, highCost: 5000 },
      { name: "Driveway", lowCost: 2000, highCost: 6000 }
    ]
  },
  {
    category: "Interior",
    items: [
      { name: "Paint Interior", lowCost: 2000, highCost: 5000 },
      { name: "Flooring (Hardwood)", lowCost: 4000, highCost: 12000 },
      { name: "Flooring (LVP)", lowCost: 2500, highCost: 6000 },
      { name: "Flooring (Carpet)", lowCost: 1500, highCost: 4000 },
      { name: "Drywall Repair", lowCost: 500, highCost: 2000 },
      { name: "Trim & Baseboards", lowCost: 1000, highCost: 3000 }
    ]
  },
  {
    category: "Systems",
    items: [
      { name: "HVAC Replacement", lowCost: 5000, highCost: 12000 },
      { name: "HVAC Repair", lowCost: 500, highCost: 2000 },
      { name: "Electrical Panel", lowCost: 1500, highCost: 4000 },
      { name: "Electrical Update", lowCost: 2000, highCost: 6000 },
      { name: "Plumbing Repair", lowCost: 500, highCost: 3000 },
      { name: "Plumbing Repipe", lowCost: 4000, highCost: 10000 },
      { name: "Water Heater", lowCost: 800, highCost: 2500 }
    ]
  }
];

export const mockDeals = [
  {
    id: 1,
    address: "742 Riverside Dr",
    city: "Austin",
    state: "TX",
    purchasePrice: 285000,
    arv: 425000,
    repairCost: 45000,
    profit: 65000,
    roi: 22.8,
    status: "analyzing",
    strategy: "flip",
    createdAt: "2025-07-10"
  },
  {
    id: 2,
    address: "1520 Lakewood Blvd",
    city: "Dallas",
    state: "TX",
    purchasePrice: 195000,
    arv: 310000,
    repairCost: 35000,
    profit: 52000,
    roi: 26.7,
    status: "funded",
    strategy: "brrrr",
    createdAt: "2025-07-08"
  },
  {
    id: 3,
    address: "890 Highland Ave",
    city: "Houston",
    state: "TX",
    purchasePrice: 165000,
    arv: 245000,
    repairCost: 28000,
    profit: 35000,
    roi: 21.2,
    status: "wholesale",
    strategy: "wholesale",
    createdAt: "2025-07-05"
  }
];

export const mockChatMessages = [
  {
    id: 1,
    role: "assistant",
    content: "Hello! I'm your PropertyARV AI assistant. I can help you analyze properties, calculate ARV, estimate repair costs, and evaluate investment strategies. What property would you like to analyze today?"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Michael Rodriguez",
    role: "Real Estate Investor",
    company: "MR Properties LLC",
    content: "PropertyARV has completely transformed how I analyze deals. What used to take me hours now takes minutes. The AI-powered ARV calculator is incredibly accurate.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100",
    deals: 47
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "House Flipper",
    company: "FlipMaster Inc",
    content: "The repair cost estimator alone has saved me from making several bad deals. It's like having a contractor in my pocket 24/7.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100",
    deals: 32
  },
  {
    id: 3,
    name: "David Thompson",
    role: "Wholesaler",
    company: "Quick Close Properties",
    content: "The professional reports have helped me close more deals with private lenders. My credibility has skyrocketed since using PropertyARV.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100",
    deals: 89
  }
];

export const mockPricingPlans = [
  {
    id: "free",
    name: "Free",
    prices: { 1: 0, 6: 0, 12: 0 },
    description: "Get started with core analysis tools",
    features: [
      "3 deal analyses per month",
      "ARV calculator",
      "Basic comp finder (5/mo)",
      "Repair estimator",
      "2 PDF reports/month",
      "Multi-language & Dark mode"
    ],
    cta: "Start Free",
    popular: false
  },
  {
    id: "starter",
    name: "Starter",
    prices: { 1: 99, 6: 89, 12: 79 },
    description: "For new investors getting serious",
    features: [
      "15 deals/month, 30 comps",
      "Deal comparison tool",
      "Rental comp analysis",
      "AI Chat (25/mo)",
      "Project manager (3 projects)",
      "CRM lead pipeline (50 leads)",
      "Contractor database (20)",
      "7-day free trial"
    ],
    cta: "Start 7-Day Trial",
    popular: false
  },
  {
    id: "pro",
    name: "Pro",
    prices: { 1: 159, 6: 139, 12: 129 },
    description: "For serious real estate investors",
    features: [
      "Unlimited deals & comps",
      "AI Chat (200/mo)",
      "Wholesale Hub & Deal Marketing",
      "Funding proposals & contracts",
      "CRM Analytics",
      "Analytics dashboard",
      "5 team members",
      "14-day free trial"
    ],
    cta: "Start 14-Day Trial",
    popular: true
  }
];

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

export const formatPercent = (value) => {
  return `${value.toFixed(1)}%`;
};
